import type { NextPage } from 'next';
import { useIntl } from 'react-intl';
import { StaticErrorContent } from '@packages/modules/src/StaticErrorContent';
import { PageMetaData } from '@packages/tracking';

/**
 * getInitialProps or getServerSideProps which is not allowed for 404.js
 * https://nextjs.org/docs/messages/404-get-initial-props
 */
const Custom404: NextPage = () => {
  const { formatMessage } = useIntl();
  return (
    <>
      <StaticErrorContent
        title={formatMessage({
          id: 'page.404.title',
          defaultMessage: '404 - SEITE WURDE NICHT GEFUNDEN',
        })}
        description={formatMessage({
          id: 'page.404.description',
          defaultMessage:
            'Leider gibt es die Seite, die du gesucht hast, auf unserer Website nicht.',
        })}
        info={formatMessage({
          id: 'page.404.info',
          defaultMessage:
            'Doch vielleicht haben wir trotzdem etwas für dich. Besuche unsere Startseite.',
        })}
        buttonLabel={formatMessage({
          id: 'page.404.button.label',
          defaultMessage: 'zur Startseite',
        })}
      />
      <PageMetaData page={{ type: 'error404', template: 'error404' }} />
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default Custom404;
